import React from 'react'
import classes from './MyStudentsAddsales.module.css'
import { Table, Tbody, Th, Thead, Tr, Heading } from '@chakra-ui/react'
import { useAddsalesStore } from '../../store/addsalesStore'
import MyStudentsAddsalesTableRecord from '../../components/MyStudentsAddsalesTableRecord/MyStudentsAddsalesTableRecord'
import Development from '../Development/Development'

function MyStudentsAddsales() {
    const [addsales, setAddsales] = useAddsalesStore(state => [state.addsales, state.setAddSales])

    return (
        <Development />
        // addsales && addsales.length > 0
        // ?
        // <div className={classes.container}>
        //     <Table>
        //         <Thead>
        //             <Tr>
        //                 <Th>Имя</Th>
        //                 <Th>Продукт</Th>
        //                 <Th>Класс</Th>
        //                 <Th>Предмет</Th>
        //                 <Th>Тэги</Th>
        //                 <Th>Купленные продукты</Th>
        //             </Tr>
        //         </Thead>
        //         <Tbody>
        //             {addsales.map(obj => (
        //                 <MyStudentsAddsalesTableRecord
        //                     addsale={obj}
        //                     key={`prolong${obj.id}`}
        //                 />
        //             ))}
        //         </Tbody>
        //     </Table>
        // </div>
        // :
        // <Heading textAlign='center'>Не удалось загрузить допродажи</Heading>
    )
}

export default MyStudentsAddsales
